module.exports = __webpack_public_path__ + "img/banner.c180c717.png";